import LandingPageBlurb from '@/app/components/LandingPage/LandingPageBlurb';

const PartnershipsExperience = () => {
  return (
    <section className="py-10 max-lg:mt-20" data-cy="partnerships-experience">
      <LandingPageBlurb
        description={{
          alignment: 'top',
          key: 'partnerships_experience_copy',
        }}
        title={{
          colEnd: { lg: 13, xxl: 11 },
          key: 'partnerships_experience_title',
          multiline: true,
        }}
      />
    </section>
  );
};

export default PartnershipsExperience;
